<template>
  <div class="gang-sheet-builder-upload">
    Have a print-ready file?&nbsp;
    <a class="gang-sheet-builder-upload__link" :href="variantUrl"> Upload Your Gang Sheet </a>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useDtfStore } from "../store";

export default {
  name: "UploadGangSheet",
  props: {
    currentStore: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState(useDtfStore, ["gangSheetBuilderSettings", "gangSheetBuilderVariants"]),
    variantUrl() {
      const variantObj = Object.values(this.gangSheetBuilderVariants).find(
        variant => variant.variant_id === this.gangSheetBuilderSettings.variantId
      );

      return this.currentStore === "ca"
        ? `/${this.currentStore}/${variantObj.product_slug}.html`
        : `/${variantObj.product_slug}.html`;
    }
  }
};
</script>

<style lang="scss">
@import "frontend/init/jiffy/settings.scss";

.gang-sheet-builder-upload {
  color: $app-gray-modern-800;
  display: flex;
  justify-content: center;
  align-items: center;

  &__link {
    color: $dropzone-highlight;
    cursor: pointer;
    text-decoration: underline;
    font-weight: 700;

    &:hover {
      color: $dropzone-highlight;
    }
  }
}
</style>
